// alterado - revisado

import React from 'react'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    GridContainer,
} from '../../../business-components/Grid/Grid'

import CadastroFormCliente from './CadastroFormCliente'

import CadastroFormConjuge from './CadastroFormConjuge'

const CadastroFormClienteConjuge = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars, linhaFormList  }) => {

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <CadastroFormCliente
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                    linhaFormList={linhaFormList}
                />

                {values.possuiConjuge
                    ?
                        <CadastroFormConjuge 
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                        />
                    :
                        ''
                }
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default CadastroFormClienteConjuge
